import { useState } from 'react';
import { Button, Group, Stack } from '@mantine/core';

const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export function NameItInput({ onAnswer }: { onAnswer: (letter: string, accidental: '#' | null) => void }) {
  const [sharp, setSharp] = useState(false);
  return (
    <Stack align="center" gap="sm">
      <Button variant={sharp ? 'filled' : 'outline'} onClick={() => setSharp((s) => !s)}>
        Sharp ♯
      </Button>
      <Group justify="center">
        {LETTERS.map((l) => (
          <Button key={l} onClick={() => onAnswer(l, sharp ? '#' : null)}>{l}</Button>
        ))}
      </Group>
    </Stack>
  );
}
